module.exports = '4.13.4';



// WEBPACK FOOTER //
// ./src/version.js